import React, { useEffect, useState } from "react";
import axios from "axios";
import { base_url } from "../Auth/BackendAPIUrl";
import { Questionnaire } from "./Questionnaire";
import { useDispatch, useSelector } from "react-redux";
import {colorCodes, illustrationFormat, illustrationStyles} from "../../json/QuestionnaireColorCodes";
import { textureImages1 } from "../../json/QuestionnaireColorCodes";
import AddCircleRoundedIcon from "@mui/icons-material/AddCircleRounded";
import InfoIcon from "@mui/icons-material/Info";
import CloseIcon from "@mui/icons-material/Close";
import X from "../../Images/Questionnaire/x icon.png";
import Blackupload from "../../Images/Questionnaire/upload.svg";
import { useLocation, useNavigate } from "react-router-dom";
import { ConfigToken } from "../Auth/ConfigToken";
import { ToastContainer } from "react-toastify";
import { Toaster } from "react-hot-toast";
import useToastMessage from "../Pages/Toaster/Toaster";
import { fetchQuestionAnswer } from "./questionnaire.slice";

import { processArabicText } from "../Utils/arabicFontParenthesisChecker";
import { handleAutoResize } from "./useAutoResize";

export const Questionnaire6 = ({
  formData,
  setFormData,
  changeLang,
  setChangeLang,
  handleBackNavigation,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const answers = useSelector((state) => state.questionnaire6);
  const currentAnswer = useSelector((state) => state.questionnaire7);
  const [selectedColors, setSelectedColors] = useState([]); // To store selected color codes
  const [inputValue, setInputValue] = useState("#"); // For input field
  const [input2Value, setInput2Value] = useState(""); // For input field
  const [isFilled, setIsFilled] = useState(null);
  const [columnGap, setColumnGap] = useState("10px");
  const [isUploading, setIsUploading] = useState(false);
  const [errors, setErrors] = useState({});
  const { showErrorToast } = useToastMessage();

    const options = [
        { value: "line art", label: "Line art", label_ar: 'فن الخط' },
        { value: "etching", label: "Etching", label_ar: 'النقش' },
        { value: "watercolor", label: "Watercolor", label_ar: 'ألوان مائية' },
        { value: "flat vector", label: "Flat vector", label_ar: 'ناقل مسطح' },
        { value: "3d", label: "3D", label_ar: '3D' },
        { value: "mascot or character", label: "Mascot or Character", label_ar: 'التميمة أو الشخصية' },
        { value: "botanical or ornamental", label: "Botanical or Ornamental", label_ar: 'نباتية أو زخرفية' },
        { value: "minimal geometric", label: "Minimal geometric", label_ar: 'هندسية الحد الأدنى' },
        { value: "other", label: "Other", label_ar: 'آخر' },
    ];
    const options2 = [
        // { value: "packaging", label: "Packaging", label_ar: 'التعبئة والتغليف' },
        { value: "social", label: "Social", label_ar: 'سوشال ميديا' },
        { value: "website", label: "Website", label_ar: 'موقع' },
        { value: "print", label: "Print", label_ar: 'مطبوعات' },
    ];
    const options3 = [
        { value: "png", label: "PNG", label_ar: 'PNG' },
        { value: "Vector", label: "Vector", label_ar: 'ناقل' },
    ];

  /* NEW QUESTIONANSWER */

  const questionAndAnswers = useSelector(
    (state) => state?.questionAnswer?.questionAndAnswers || []
  );
    const orderData = useSelector((state) => state?.questionAnswer?.orderData);
  const orderId = useSelector((state) => state?.questionAnswer?.orderId);
  const [questionAnswer4, setQuestionAnswer4] = useState([]);

  useEffect(() => {
    if (questionAndAnswers?.length > 0) {
      setQuestionAnswer4(questionAndAnswers);
        let values = illustrationStyles.map(f => f.value);
        const question27 = questionAndAnswers.find(q => q.id === 27);
        if (question27) {
          // If answer is a string (not an object with documents), set input value
          if (typeof question27.answer === "string" && !values.includes(question27.answer)) {
            setInput2Value(question27.answer);
          } else if (typeof question27.answer === "string" && values.includes(question27.answer)) {
            // If it's a thumbnail value, clear input
            setInput2Value("");
          } else if (question27.answer?.documents) {
            // If it's an object (documents), clear input
            setInput2Value("");
          } else {
            // If answer is empty or undefined, clear input
            setInput2Value("");
          }
        }
    }
  }, [questionAndAnswers]);

  // Helper function to filter out duplicate questions across categories
  const filterDuplicateQuestions = (questions, currentCategory) => {
    const answeredQuestionIds = questionAndAnswers
      .filter(q => {
        const answer = q.answer;
        if (!answer) return false;
        if (typeof answer === "string" && answer.trim() !== "") return true;
        if (Array.isArray(answer) && answer.length > 0) return true;
        if (typeof answer === "object" && !Array.isArray(answer) && Object.keys(answer).length > 0) return true;
        return false;
      })
      .map(q => q.id);

    return questions.filter(q => {
      const isAnswered = answeredQuestionIds.includes(q.id);
      const categories = q.category?.split(',') || [];
      const hasMultipleCategories = categories.length > 1;
        const hasBrandIdentity = orderData?.brand_identity && Object.keys(orderData.brand_identity).length > 0;
      if (hasBrandIdentity && hasMultipleCategories) {
          return false;
      }
      
      if (isAnswered && hasMultipleCategories) {
        const answeredQuestion = questionAndAnswers.find(aq => aq.id === q.id);
        if (answeredQuestion) {
          const answeredCategories = answeredQuestion.category?.split(',') || [];
          return answeredCategories.includes(currentCategory);
        }
      }
      return true;
    });
  };

  const countWords = (str) => {
    if (!str || typeof str !== "string") return 0;
    return str.trim().split(/\s+/).filter((word) => word.length > 0).length;
  };

  /* NEW QUESTIONANSWER */

  useEffect(() => {
    window.onbeforeunload = () => {
      sessionStorage.setItem("isReload", "true");
    };
      document.addEventListener("touchstart", function(){}, true);
    return () => {
      window.onbeforeunload = null;
    };
  }, []);

  // Detect refresh on mount
  useEffect(() => {
    if (sessionStorage.getItem("isReload") === "true") {
      sessionStorage.removeItem("isReload");
      navigate("/questionnaire/1");
    }
  }, [navigate]);

  const placeHolders = ["", "BUNDL", "(ex: Luxury shopping made easy)"];
  const placeHolders_arabic = ["", "باقة", "تسوق بسهولة"];

  useEffect(() => {
    const updateColumnGap = () => {
      if (window.innerWidth <= 375) {
        setColumnGap("8px");
      } else if (window.innerWidth >= 375 && window.innerWidth <= 500) {
        setColumnGap("13px");
      } else {
        setColumnGap("10px");
      }
    };

    updateColumnGap(); // Initial call
    window.addEventListener("resize", updateColumnGap);

    return () => window.removeEventListener("resize", updateColumnGap);
  }, [window?.innerWidth]);

  useEffect(() => {

    const fetchAnswers = async () => {
      try {
        if (location?.state?.orderId != undefined) {
          const response = await axios.get(
            `${base_url}/api/questionnaire/update/${location?.state?.orderId}`,
            ConfigToken()
          );
          const answers = response?.data?.data;

          answers.forEach((item) => {
            const { question_id, answer, answer_type } = item;

            setFormData((prevFormData) => ({
              ...prevFormData,
              [question_id]: answer,
            }));

            switch (question_id) {
              case 19: // Colors (array of hex values)
                if (Array.isArray(answer)) {
                  setSelectedColors(answer); // Update selected colors
                }
                break;

              default:
                console.warn(`Unhandled question_id: ${question_id}`);
                break;
            }
          });
        }
      } catch (error) {
        console.error("Error fetching questions:", error);
      }
    };

    setFormData(currentAnswer);

    if (currentAnswer && Object.values(currentAnswer).length) {
      setSelectedColors(currentAnswer && currentAnswer[19]);
    }
    fetchAnswers();
  }, []);

  const displayedColors = colorCodes.slice(0, 90);

  const showToastMessage = () => {
    showErrorToast(
      changeLang === "ar" ? "القيمة مطلوب" : "The Value is required!",
      "#D83D99"
    );
  };

  const isValidUrl = (url) => {
    const urlPattern = /^(https?:\/\/)?([\w-]+\.)+[\w-]+(\/[\w-./?%&=]*)?$/i;
    return urlPattern.test(url);
  };

  const validateFields = () => {
    // Check for word count limit
    const wordLimitExceeded = questionAnswer4.some((q) => {
      if (q.id === 19) return countWords(inputValue) > 70;
      if (q.id === 27) return countWords(input2Value) > 70;
      if (q.answer_type !== "input") return false;
      return countWords(q.answer) > 70;
    });

    if (wordLimitExceeded) {
      const questionWithLimitError = questionAnswer4.find((q) => {
        if (q.id === 19) return countWords(inputValue) > 70;
        if (q.id === 27) return countWords(input2Value) > 70;
        if (q.answer_type !== "input") return false;
        return countWords(q.answer) > 70;
      });
      if (questionWithLimitError) {
        setErrors((prev) => ({
          ...prev,
          [questionWithLimitError.id]: changeLang === "ar" ? "يجب ألا يتجاوز النص 70 كلمة" : "Text should not exceed 70 words",
        }));
        setIsFilled(questionWithLimitError.id);
        const element = document.getElementById(`question_${questionWithLimitError.id}`);
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }
      return false;
    }

    // Filter required questions that are either unanswered or contain invalid data
    const unansweredRequiredQuestions = questionAnswer4
      .filter(f => f.category.split(',').includes('illustration')).sort((a, b)=> a.sort_order - b.sort_order)
      .filter((q) => {
        const answer = q.answer;
        if (!q.required) {
          return false;
        }

        // Special validation for thumbnail questions (can have string value OR documents)
        if (q.answer_type === 'thumbnail') {
          const hasStringValue = typeof answer === "string" && answer.trim() !== "";
          const hasDocuments = answer?.documents && Array.isArray(answer.documents) && answer.documents.length > 0;
          
          // Require at least one: thumbnail selected, text entered, or image uploaded
          return !hasStringValue && !hasDocuments;
        }

        // Special validation for question 21 (file upload or link)
        if (q.answer_type === 'file/link') {
          const hasLink = answer?.link && answer.link.trim() !== "";
          const hasDocuments = answer?.documents && answer.documents.length > 0;
          
          // If link exists, validate it
          if (hasLink && !isValidUrl(answer.link.trim())) {
            return true; // Invalid link, mark as invalid
          }
          
          return !hasLink && !hasDocuments;
        }

        if (
          answer === undefined ||
          answer === null ||
          (typeof answer === "string" && answer.trim() === "") ||
          (Array.isArray(answer) && answer?.length === 0) ||
          (typeof answer === "object" &&
            !Array.isArray(answer) &&
            Object.keys(answer).length === 0)
        ) {
          return true;
        }

        return false; // Valid answer
      });

    if (unansweredRequiredQuestions?.length > 0) {
      const invalidQuestion = unansweredRequiredQuestions[0];
        console.log('invalidQuestion', invalidQuestion);
      const element = document.getElementById(
        `question_${invalidQuestion?.id}`
      );
      setIsFilled(invalidQuestion?.id);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
      
      // Show specific error for invalid link
      if (invalidQuestion?.answer_type === 'file/link' && invalidQuestion?.answer?.link) {
        showErrorToast(
          changeLang === "ar" ? "الرجاء إدخال رابط صالح!" : "Please enter a valid link!",
          "#D83D99"
        );
      } else {
        showToastMessage();
      }
      return false;
    }

    return true;
  };

  const handleColorClick = (color, questionId) => {
    let updatedColors = [];
    if (questionId === 19) {
      setInputValue("");
      if (color) {
        // Format color code if needed
        let formattedColor = color;
        if (color !== "Surprise" && !color.startsWith('#')) {
          formattedColor = `#${color}`;
        }
        
        // Validate hex code if not Surprise
        if (formattedColor !== "Surprise") {
          const isHexCode = /^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6})$/.test(formattedColor);
          if (!isHexCode) {
            showErrorToast(
              changeLang === "ar" ? "HEX يُسمح فقط بكود  " : "Allows only HEX Code!",
              "#D83D99"
            );
            setInputValue("");
            return;
          }
        }
        
        if (formattedColor === "Surprise") {
          // Reset colors if Surprise
          setQuestionAnswer4((prev) =>
            prev?.map((ele) =>
              ele.id === questionId
                ? {
                    ...ele,
                    answer: {
                      type: prev?.answer?.type === "Surprise" ? "" : "Surprise",
                      color: [],
                    },
                  }
                : ele
            )
          );
          setSelectedColors([]);
        } else {
          setQuestionAnswer4((prev) => {
            return prev.map((ele) => {
              if (ele.id === questionId) {
                const existingColors = ele.answer?.color || [];
                // Normalize colors for comparison (uppercase, ensure # prefix)
                const normalizeColor = (c) => {
                  if (!c || c === "Surprise") return c;
                  let normalized = c.trim();
                  if (!normalized.startsWith('#')) {
                    normalized = `#${normalized}`;
                  }
                  return normalized.toUpperCase();
                };
                
                const normalizedFormattedColor = normalizeColor(formattedColor);
                const normalizedExistingColors = existingColors.map(normalizeColor);
                
                if (normalizedExistingColors.includes(normalizedFormattedColor)) {
                  showErrorToast(
                    changeLang === "ar"
                      ? "تمت إضافة اللون مسبقا!"
                      : "You have already added!",
                    "#D83D99"
                  );
                  return ele;
                }

                const updatedColorsArray = [...existingColors, formattedColor];
                setSelectedColors(updatedColorsArray);
                
                return {
                  ...ele,
                  answer: {
                    ...ele.answer,
                    type: "",
                    color: updatedColorsArray,
                  },
                };
              }
              return ele;
            });
          });
        }
      }
      return; // Early return to prevent executing the code below
    }
    if (!color.startsWith('#')) {
        color = `#${color}`;
    }
    const isHexCode = /^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6})$/.test(color);

    if (!isHexCode && color !== "Surprise") {
      showErrorToast(
        changeLang === "ar" ? "HEX يُسمح فقط بكود  " : "Allows only HEX Code!",
        "#D83D99"
      );
      setInputValue("");
      return;
    }

    if (selectedColors?.includes(color)) {
      showErrorToast(
        changeLang === "ar"
          ? "تمت إضافة اللون مسبقا!"
          : "You have already added!",
        "#D83D99"
      );
    }

    let colorsArray = selectedColors || [];

    if (color === "Surprise") {
      updatedColors = ["Surprise"];
    } else {
      updatedColors = colorsArray.includes("Surprise")
        ? colorsArray.filter((item) => item !== "Surprise")
        : [...colorsArray];

      if (!updatedColors.includes(color)) {
        updatedColors.push(color);
      }
    }

    setSelectedColors(updatedColors);
    setInputValue("");
    setQuestionAnswer4((prev) =>
      prev?.map((ele) =>
        ele.id === questionId
          ? { ...ele, answer: { ...ele.answer, color: updatedColors } }
          : ele
      )
    );
  };

  // const handleRemoveColor = (color, questionId) => {
  //   const updatedColors = questionAnswer4?.filter((c) => c.id === questionId?answer: answers:c.answer);
  //
  //   setSelectedColors(updatedColors);

  //   setQuestionAnswer4((prevFormData) => ({
  //     ...prevFormData,
  //     answer: {
  //       color: updatedColors,
  //     },
  //   }));
  // };

  const handleRemoveColor = (colorToRemove, questionId) => {
    const updatedColors =
      questionAnswer4
        ?.find((q) => q.id === questionId)
        ?.answer?.color?.filter((c) => c !== colorToRemove) || [];

    setSelectedColors(updatedColors);

    setQuestionAnswer4((prev) =>
      prev.map((ele) =>
        ele.id === questionId
          ? {
              ...ele,
              answer: {
                ...ele.answer,
                color: updatedColors,
              },
            }
          : ele
      )
    );
  };

  const handleInputChange = (questionId, e) => {
    const value = e?.target?.value || "";
    if (countWords(value) > 70) {
      setErrors((prev) => ({
        ...prev,
        [questionId]:
          changeLang === "ar"
            ? "يجب ألا يتجاوز النص 70 كلمة"
            : "Text should not exceed 70 words",
      }));
    } else {
      setErrors((prev) => {
        const updated = { ...prev };
        if (updated[questionId] === (changeLang === "ar" ? "يجب ألا يتجاوز النص 70 كلمة" : "Text should not exceed 70 words")) {
          delete updated[questionId];
        }
        return updated;
      });
    }

    // For question 19 (colors), only update the input value state
    // Don't modify questionAnswer4 to preserve the color array
    if (questionId === 19) {
      setInputValue(value);
      return;
    }
    
    // For other questions, update the answer normally
    setQuestionAnswer4((prev) =>
      prev.map((ele) =>
        ele.id === questionId ? { ...ele, answer: value } : ele
      )
    );
    setInputValue(value);
  };

  const handleInput2Change = (questionId, e) => {
    const value = e?.target?.value || "";
    if (countWords(value) > 70) {
      setErrors((prev) => ({
        ...prev,
        [questionId]:
          changeLang === "ar"
            ? "يجب ألا يتجاوز النص 70 كلمة"
            : "Text should not exceed 70 words",
      }));
    } else {
      setErrors((prev) => {
        const updated = { ...prev };
        if (updated[questionId] === (changeLang === "ar" ? "يجب ألا يتجاوز النص 70 كلمة" : "Text should not exceed 70 words")) {
          delete updated[questionId];
        }
        return updated;
      });
    }

    // For question 27 (thumbnail), only update the input value state
    // Don't modify questionAnswer4 until blur to preserve documents if they exist
    if (questionId === 27) {
      // Always update input2Value, even if empty (allows clearing)
      setInput2Value(value);
      return;
    }

    // For other questions, update the answer normally
    setQuestionAnswer4((prev) =>
      prev.map((ele) =>
        ele.id === questionId ? { ...ele, answer: value } : ele
      )
    );
    setInput2Value(value);
  };

  const handleInput2Blur = (questionId, e) => {
    // For question 27 (thumbnail), update answer on blur and clear documents
    if (questionId === 27) {
      const textValue = e?.target?.value?.trim() || "";
      setQuestionAnswer4((prev) =>
        prev.map((ele) =>
          ele.id === questionId 
            ? { 
                ...ele, 
                answer: textValue // Store as string, clearing any documents
              } 
            : ele
        )
      );
    }
  };

  const handleChange = (questionId, value) => {
    if (countWords(value) > 70) {
      setErrors((prev) => ({
        ...prev,
        [questionId]:
          changeLang === "ar"
            ? "يجب ألا يتجاوز النص 70 كلمة"
            : "Text should not exceed 70 words",
      }));
    } else {
      setErrors((prev) => {
        const updated = { ...prev };
        if (updated[questionId] === (changeLang === "ar" ? "يجب ألا يتجاوز النص 70 كلمة" : "Text should not exceed 70 words")) {
          delete updated[questionId];
        }
        return updated;
      });
    }

    setQuestionAnswer4((prev) =>
      prev.map((ele) =>
        ele.id === questionId
          ? {
              ...ele,
              answer: value,
            }
          : ele
      )
    );
  };

  const handleMultiChange = (e, questionId) => {
      const { value, checked } = e.target;
      setQuestionAnswer4((prev) => {
          return prev.map((ele) => {
              if (ele.id !== questionId) return ele;

              const currentSelections = ele.answer || [];

              if (checked) {
                  return {
                      ...ele,
                      answer: [
                          ...currentSelections,
                          value,
                      ],
                  };
              } else {
                  return {
                      ...ele,
                      answer: currentSelections.filter((item) => item !== value),
                  };
              }
          });
      });
  }

  const handleTextureChange = (e, questionId) => {
      const { value, checked } = e.target;
      setQuestionAnswer4((prev) => {
          return prev.map((ele) => {
              if (ele.id !== questionId) return ele;

              // When thumbnail is selected, store as string value and clear documents
              if (checked) {
                  // Clear input value when thumbnail is selected
                  setInput2Value("");
                  return {
                      ...ele,
                      answer: value, // Store as string, clearing any documents
                  };
              } else {
                  return {
                      ...ele,
                      answer: value,
                  };
              }
          });
      });
  };

  const removeDocument = (indexToRemove, id) => {
    setQuestionAnswer4((prev) =>
      prev.map((ele) => {
        if (ele.id !== id) return ele;
        
        const currentDocuments = ele.answer?.documents || [];
        const remainingDocuments = currentDocuments.filter(
          (_, i) => i !== indexToRemove
        );
        
        // Clear input value when removing documents
        if (id === 27) {
          setInput2Value("");
        }
        
        // If no documents remain, reset to empty string
        if (remainingDocuments.length === 0) {
          return {
            ...ele,
            answer: "",
          };
        }
        
        // Otherwise, keep documents array
        return {
          ...ele,
          answer: {
            documents: remainingDocuments,
          },
        };
      })
    );
  };

  const uploadFile = async (e, id, field) => {
    const files = Array.from(e.target.files);
    if (!files.length) return;

    setIsUploading(true);
    try {
      const uploadedFiles = await Promise.all(
        files.map(async (file) => {
          const formData = new FormData();
          formData.append("file", file);
          formData.append("file_name", file.name);

          const response = await axios.post(
            `${base_url}/api/upload_file/`,
            formData,
            ConfigToken()
          );

          return {
            docName: file.name,
            document: response.data.file_url,
          };
        })
      );

      setQuestionAnswer4((prev) =>
        prev.map((ele) => {
          if (ele.id !== id) return ele;
          
          // Clear input value when files are uploaded
          if (id === 27) {
            setInput2Value("");
          }
          
          return {
            ...ele,
            answer: {
              documents: [
                ...(ele.answer?.documents || []), // existing files
                ...uploadedFiles, // new files
              ],
            },
          };
        })
      );
    } catch (error) {
      console.error("Error uploading files:", error);
      showErrorToast(
        changeLang === "ar" ? "خطأ في رفع الملفات" : "Error uploading files",
        "#D83D99"
      );
    } finally {
      setIsUploading(false);
    }
  };

  const onBackClick = async () => {
    dispatch(fetchQuestionAnswer(questionAnswer4));
    if (handleBackNavigation) {
      handleBackNavigation(6);
    } else {
      navigate(`/questionnaire/${5}`);
    }
  };

  const onNextClick = () => {
    if (!validateFields()) {
      return; // Stop execution if validation fails
    }
    dispatch(fetchQuestionAnswer(questionAnswer4));
    navigate(`/questionnaire/${7}`, {
      state: {
        orderId: location?.state?.orderId,
      },
    });
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  let newUpdatedAns = questionAnswer4.map((ele) => {
    return {
      id: ele.id,
      answers: ele.answer,
    };
  });

  const onSaveLaterClick = async () => {
    let data = {
      answers: newUpdatedAns,
      orderId: orderId,
      status: "not submitted",
    };
    try {
      const response = await axios.post(
        `${base_url}/api/questionnaire/create`,
        data,
        ConfigToken()
      );
      if (response.status === 200) {
        navigate("/dashboard", {
          state: {
            orderId: location?.state?.orderId,
          },
        });
      }
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    if (questionAnswer4[18]) {
      console.log(questionAnswer4[18]);
    }
  }, []);

  return (
    <div>
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            // color: "#1BA56F",
            fontWeight: "700",
            borderRadius: "0px !important",
            border: `1px solid #1BA56F`,
          },
        }}
      />
      <ToastContainer />
      <Questionnaire
        pageNo={6}
        Qlang={changeLang}
        setQLang={setChangeLang}
        storeAnswers={answers}
        orderId={location.state?.orderId}
        onBackClick={onBackClick}
        onNextClick={onNextClick}
        onSaveLaterClick={onSaveLaterClick}
        formData={formData}
        setFormData={setFormData}
        questions={
          <>
            {/* ${question.id == 21 ?'!text-[22px]':''} */}
            {filterDuplicateQuestions(questionAnswer4?.filter(f => f.category.split(',').includes('illustration')), 'illustration').sort((a, b) => a.sort_order - b.sort_order)?.map((question, index) => (
              <div
                className="questions"
                key={index}
                id={`question_${question.id}`}
              >
                  <p
                      className={`questions-title  xs:w-[90%] sm:w-full md:w-full mx-auto ${
                          index === 0 ? "mt-[1.5%]" : "mt-[2%]"
                      } `}
                  >
                      {changeLang === "ar"
                          ? processArabicText(question?.question_arabic)
                          : question?.question}
                      {question?.required && (
                          <span
                              className={`required-asterisk ${
                                  question?.id === 21 ? "required-asterisk--large" : ""
                              }`}
                              aria-hidden="true"
                          >
                        *
                      </span>
                      )}
                  </p>

                {question?.answer_type === "color" && (
                  <>
                    <div
                      className="color-grid"
                      style={{
                        display: "grid",
                        gridTemplateColumns: "repeat(9, 1fr)",
                        margin: "2% 0 0 0",
                        padding: "0% 10%",
                        columnGap: columnGap,
                      }}
                    >
                      {displayedColors?.map((color, index) => {
                        const isTopRow = index < 9;
                        const isBottomRow = index >= displayedColors.length - 9;

                        const borderRadiusStyle = {
                          borderTopLeftRadius: isTopRow ? "8px" : "0", // Top-left corner
                          borderTopRightRadius: isTopRow ? "8px" : "0", // Top-right corner
                          borderBottomLeftRadius: isBottomRow ? "8px" : "0", // Bottom-left corner
                          borderBottomRightRadius: isBottomRow ? "8px" : "0", // Bottom-right corner
                        };

                        return (
                          <div
                            key={index}
                            className={`specific-color ${
                              selectedColors?.includes(color)
                                ? "border-[1px] border-black"
                                : ""
                            }`}
                            style={{
                              backgroundColor: `${colorCodes[index]}`,
                              ...borderRadiusStyle,
                            }}
                            onClick={() => handleColorClick(color, question.id)}
                          ></div>
                        );
                      })}
                    </div>
                    <div
                      className="selected-colors"
                      style={{
                        display: "flex",
                        gap: window?.innerWidth <= 475 ? "5px" : "10px",
                        marginTop: "20px",
                        flexWrap: "wrap",
                        width: window?.innerWidth <= 475 ? "100%" : "75%",
                        alignItems: "center",
                        justifyContent: "center",
                        height: "inherit",
                      }}
                    >
                      {question?.answer?.type === "Surprise"
                        ? ""
                        : question?.answer?.color?.map((color, index) => {
                            return (
                              <div
                                key={index}
                                className="selected-color"
                                style={{
                                  backgroundColor: color,
                                  width: "120px",
                                  height: "30px",
                                  border: "1px solid #000000",
                                }}
                              >
                                <span
                                  style={{
                                    // margin: '-5% 1% 0 0',
                                    float: "right",
                                    cursor: "pointer",
                                  }}
                                >
                                  <img
                                    src={X}
                                    alt="X-icon"
                                    onClick={() =>
                                      handleRemoveColor(color, question.id)
                                    }
                                  ></img>
                                </span>
                              </div>
                            );
                          })}
                    </div>
                    <div
                      className="color-input"
                      style={{
                        marginTop: "20px",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        gap: "10px",
                        position: "relative",
                      }}
                    >
                      <p className="enter-colors">
                        {changeLang === "ar"
                          ? "او اكتب الكود الخاص للألوان اللي تفضل نستخدمها للهوية"
                          : "OR enter the hex code of colours you want."}
                      </p>
                      <div className="flex justify-center items-center">
                        <input
                          type="text"
                          value={inputValue}
                          onChange={(e) => handleInputChange(question.id, e)}
                          placeholder="ex: #E1483D"
                          style={{
                            padding: "8px",
                            border: "1px solid #000",
                            outline: "none",
                            width: window.innerWidth <= 441 ? "250px" : "400px",
                            height: "44.5px",
                            borderRadius: "0px",
                          }}
                        />
                        <div
                          className={`word-counter ${
                            countWords(inputValue) > 70 ? "limit-exceeded" : ""
                          }`}
                          style={{ position: "absolute", bottom: "-25px" }}
                        >
                          {changeLang === "ar" ? "كلمات" : "Words"}:{" "}
                          {countWords(inputValue)} / 70
                        </div>
                        {question.id in errors && (
                          <p className="text-[#D83D99] absolute bottom-[-45px]">
                            {errors[question.id]}
                          </p>
                        )}
                        <button
                          onClick={() =>
                            handleColorClick(inputValue, question.id)
                          }
                          style={{
                            padding: "8px 16px",
                            backgroundColor: "#000000",
                            color: "#fff",
                            border: "none",
                            cursor: "pointer",
                            margin:
                              window.innerWidth <= 441
                                ? "0 0 0 -18%"
                                : "0 0px 0px -12%",
                          }}
                        >
                          <AddCircleRoundedIcon
                            onClick={() =>
                              handleColorClick(inputValue, question.id)
                            }
                          />
                        </button>
                      </div>
                      <p className="lg:text-[24px] md:text-[18px] xs:text-[14px] leading-1 font-[500] mb-0 lg:mt-[8%] md:mt-[7%] xs:mt-[8%]">
                        {changeLang === "ar"
                          ? "غير متأكد ؟ لا بأس!"
                          : "Not sure ? It's okay!"}
                      </p>
                      <button
                        className={`${
                          question?.answer?.type
                            ? "surprise-active"
                            : "surprise"
                        }`}
                        onClick={() =>
                          handleColorClick("Surprise", question.id)
                        }
                      >
                        {changeLang === "ar" ? "فاجأني!" : "surprise me !"}
                      </button>
                    </div>
                  </>
                )}
                  {question.answer_type === "brand" && (
                      <div
                          style={window?.innerWidth <= 500 ? { display: "grid", gap: "10px", marginBottom: "3%", gridTemplateColumns: 'repeat(2, 1fr)' }: { display: "flex", gap: "10px", marginBottom: "3%" }}
                      >
                          {options2.map((option, index) => (
                              <button key={index}
                                  className={`product-btn ${
                                      (question?.answer || []).includes(option.value) ? "active" : ""
                                  }`}
                                  onClick={(e) => handleMultiChange({
                                      target: {
                                          value: option.value,
                                          checked: !(question?.answer || []).includes(option.value),
                                      },
                                  }, question.id)}
                              >
                                  {changeLang === "ar" ? option.label_ar : option.label}
                              </button>
                          ))}
                      </div>
                  )}
                  {question.answer_type === "brand2" && (
                      <>
                          <div className="form-group lg:w-[75%] md:w-[100%]">
                              <span className="font-error valid-error text-purple"></span>
                              <ul
                                  style={
                                      window?.innerWidth <= 500
                                          ? {
                                              display: "grid",
                                              gridTemplateColumns: "repeat(2,1fr)",
                                          }
                                          : {}
                                  }
                                  className={
                                      window?.innerWidth <= 500
                                          ? "checkbox-btn-img"
                                          : `h-list select-btns grid-view padding-top-20 checkbox-btn-img h-list-check`
                                  }
                              >
                                  {illustrationFormat.map((option, index) => (
                                      <li className="checkbox checkbox-btn" key={index} style={{ position: 'relative' }}>
                                        {option.info && (
                                              <div 
                                                  style={{
                                                      position: 'absolute',
                                                      top: '-0',
                                                      right: '20px',
                                                      zIndex: 10,
                                                      cursor: 'pointer'
                                                  }}
                                                  className="info-icon-wrapper"
                                              >
                                                  <InfoIcon 
                                                      style={{ 
                                                          fontSize: '24px', 
                                                          color: '#666',
                                                          transition: 'color 0.2s'
                                                      }}
                                                  />
                                                  <div
                                                      style={{
                                                          position: 'absolute',
                                                          top: '24px',
                                                          right: '0',
                                                          backgroundColor: '#000',
                                                          color: '#fff',
                                                          padding: '8px 12px',
                                                          borderRadius: '4px',
                                                          fontSize: '12px',
                                                          width: '200px',
                                                          lineHeight: '1.4',
                                                          zIndex: 1000,
                                                          boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
                                                          whiteSpace: 'normal',
                                                          wordWrap: 'break-word'
                                                      }}
                                                      className="info-tooltip"
                                                  >
                                                      {option.info}
                                                      <div
                                                          style={{
                                                              position: 'absolute',
                                                              top: '-6px',
                                                              right: '12px',
                                                              width: 0,
                                                              height: 0,
                                                              borderLeft: '6px solid transparent',
                                                              borderRight: '6px solid transparent',
                                                              borderBottom: '6px solid #000'
                                                          }}
                                                      ></div>
                                                  </div>
                                              </div>
                                          )}
                                          <input
                                              type="checkbox"
                                              checked={question?.answer === option.value}
                                              value={option.value}
                                              id={`${question.id}-${option.value.split(' ').join('-')}`}
                                              className="validThis"
                                              onChange={(e) =>
                                                  handleTextureChange(e, question.id)
                                              }
                                          ></input>
                                          <label htmlFor={`${question.id}-${option.value.split(' ').join('-')}`} className={'h-64 relative'}>
                                              <figure className="image-container img-animation !h-[80%]" onMouseEnter={(e) => e.target.parentElement.classList.add('animate')} onMouseLeave={(e) => e.target.parentElement.classList.remove('animate')}>
                                                  {option.img?.map((images) => {
                                                      return (
                                                          <img
                                                              src={images}
                                                              alt="Clean"
                                                          ></img>
                                                      );
                                                  })}
                                              </figure>
                                              <span className="button-text !text-[16px] absolute bottom-0 w-full" style={{lineHeight: 1}}>
                              {changeLang === "ar" ? option.fontStyle_arabic : option.fontStyle}
                            </span>
                                          </label>
                                      </li>
                                  ))}
                              </ul>
                          </div>
                      </>
                  )}

                  {question?.answer_type === "thumbnail" && (
                          <>
                              <div className="form-group w-full">
                                  <span className="font-error valid-error text-purple"></span>
                                  <ul
                                      className={`select-btns checkbox-btn-img !grid grid-cols-1 md:grid-cols-2 slg:grid-cols-3`}
                                  >
                                      {illustrationStyles.map((option, index) => (
                                          <li className="checkbox checkbox-btn !w-full" key={index}>
                                              <input
                                                  type="checkbox"
                                                  checked={question?.answer === option.value}
                                                  value={option.value}
                                                  id={`${question.id}-${option.value.split(' ').join('-')}`}
                                                  className="validThis"
                                                  onChange={(e) =>
                                                      handleTextureChange(e, question.id)
                                                  }
                                              ></input>
                                              <label htmlFor={`${question.id}-${option.value.split(' ').join('-')}`} className={'h-32 md:h-64 relative'}>
                                                  <figure className="image-container img-animation !h-[80%]" onMouseEnter={(e) => e.target.parentElement.classList.add('animate')} onMouseLeave={(e) => e.target.parentElement.classList.remove('animate')}>
                                                      {option.img?.map((images) => {
                                                          return (
                                                              <img
                                                                  src={images}
                                                                  alt="Clean"
                                                              ></img>
                                                          );
                                                      })}
                                                  </figure>
                                                  <span className="button-text !text-[16px] absolute bottom-0 w-full">
                              {changeLang === "ar" ? option.fontStyle_arabic : option.fontStyle}
                            </span>
                                              </label>
                                          </li>
                                      ))}
                                  </ul>
                              </div>
                              <p className="enter-colors">
                                  {changeLang === "ar"
                                      ? "هل لديك مراجع أدق؟ ارفعها هنا"
                                      : "Do you have more accurate references, upload them here"}
                              </p>
                              <div
                                  className="color-input"
                                  style={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: "10px",
                                      position: "relative",
                                      ...(window?.innerWidth <= 500 ? {flexDirection: "column"}: {})
                                  }}
                              >
                                  <div className="flex justify-center items-center">
                                      <textarea
                                          onBlur={(e) => handleInput2Blur(question.id, e)}
                                          value={input2Value}
                                          onChange={(e) => {
                                            handleInput2Change(question.id, e);
                                            handleAutoResize(e, 200);
                                          }}
                                          onInput={(e) => handleAutoResize(e, 200)}
                                          placeholder="ex: Line Art"
                                          style={{
                                              padding: "8px",
                                              border: "1px solid #000",
                                              outline: "none",
                                              width: window.innerWidth <= 441 ? "250px" : "400px",
                                              minHeight: "44.5px",
                                              borderRadius: "0px",
                                              resize: "none",
                                              overflowY: "auto",
                                          }}
                                          rows={1}
                                      />
                                      <div className={`word-counter ${countWords(input2Value) > 70 ? "limit-exceeded" : ""}`}>
                                          {changeLang === "ar" ? "كلمات" : "Words"}: {countWords(input2Value)} / 70
                                      </div>
                                      {question.id in errors && (
                                        <p className="text-[#D83D99]">{errors[question.id]}</p>
                                      )}
                                  </div>
                                  {changeLang === 'ar'? 'أو' : 'OR'}
                                  <>
                                    <p
                                      className={`border-1 h-[45px] lg:text-[18px] md:text-[18px] xs:text-[14px] uppercase
                                        ${
                                          window?.innerWidth <= 500
                                            ? "w-[100%]"
                                            : "w-[300px]"
                                        }
                                      !border-[#000000] flex items-center justify-center text-[#000000] cursor-pointer lg:ml-2 lg:mt-4 md:ml-2 md:mt-4 xs:ml-0 xs:mt-0 p-[5px] ${
                                        isUploading ? "opacity-50 cursor-not-allowed" : ""
                                      }`}
                                      onClick={() => {
                                        if (!isUploading) {
                                          document
                                            .getElementById(`file-${question.id}`)
                                            .click();
                                        }
                                      }}
                                    >
                                      <input
                                        type="file"
                                        hidden
                                        multiple
                                        name="file"
                                        id={`file-${question.id}`}
                                        onChange={(e) => uploadFile(e, question.id, "file")}
                                        className=""
                                        disabled={isUploading}
                                        accept="image/*"
                                      />
                                      {isUploading ? (
                                        <div className="flex items-center">
                                          <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-black mr-2"></div>
                                          {changeLang === "ar" ? "جاري الرفع..." : "Uploading..."}
                                        </div>
                                      ) : (
                                        <>
                                          <img
                                            className="h-[25px] w-[40px]"
                                            src={Blackupload}
                                            alt="Upload Icon"
                                          />
                                          {changeLang === "ar"
                                            ? "إضافة المحتوى"
                                            : "Upload Content"}
                                        </>
                                      )}
                                    </p>
                                  </>
                                  {question?.answer?.documents?.length > 0 && (
                                    <div className="flex flex-wrap justify-center">
                                      {question.answer.documents.map(({ docName }, i) => (
                                        <div
                                          key={i}
                                          className="bg-black text-[14px] text-white py-1 px-2 mr-2 mb-2 flex items-center"
                                        >
                                          {docName}
                                          <CloseIcon
                                            onClick={() => removeDocument(i, question.id)}
                                            className="ml-2 cursor-pointer"
                                          />
                                        </div>
                                      ))}
                                    </div>
                                  )}
                              </div>
                          </>
                  )}
                  {question?.answer_type === "input" && (
                    <>
                      <textarea
                        placeholder={
                            changeLang === ""
                                ? placeHolders_arabic[index]
                                : placeHolders[index]
                        }
                        value={question.answer}
                        className={`question-input ${
                            isFilled === question?.id
                                ? "border-[#D83D99]  border-b-[2px]"
                                : `${
                                    window?.innerWidth <= 475
                                        ? "border-b-[1px]"
                                        : "border-b-[2px]"
                                } border-black`
                        }`}
                        onChange={(e) => {
                          handleChange(question.id, e.target.value);
                          handleAutoResize(e, 200);
                        }}
                        onInput={(e) => handleAutoResize(e, 200)}
                        rows={1}
                      />
                      <div className={`word-counter ${countWords(question.answer) > 70 ? "limit-exceeded" : ""}`}>
                        {changeLang === "ar" ? "كلمات" : "Words"}: {countWords(question.answer)} / 70
                      </div>
                      {question.id in errors && (
                        <p className="text-[#D83D99]">{errors[question.id]}</p>
                      )}
                    </>
                  )}
                  {question?.answer_type !== "input" &&
                  <div
                      className={`w-[100%] xl:h-[2px] lg:h-[2px] md:h-[2px] sm:h-[2px] xs:h-[1px] ${isFilled === question?.id ? 'bg-[#D83D99]': 'bg-black'} mt-[3%]`}
                  ></div>
                  }
              </div>
            ))}
          </>
        }
        bgTitle={changeLang === "ar" ? "الرسومات" : "Illustration"}
      />
    </div>
  );
};
